export class LocalStorage {
    get(key) {
        var _a;
        try {
            return ((_a = globalThis.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(key)) || null;
        }
        catch (error) {
            console.warn("Unable to access localStorage:", error);
            return null;
        }
    }
    set(key, value, _ttl) {
        var _a;
        try {
            (_a = globalThis.localStorage) === null || _a === void 0 ? void 0 : _a.setItem(key, value);
        }
        catch (error) {
            console.warn("Unable to write to localStorage:", error);
        }
    }
    delete(key) {
        var _a;
        try {
            (_a = globalThis.localStorage) === null || _a === void 0 ? void 0 : _a.removeItem(key);
        }
        catch (error) {
            console.warn("Unable to remove from localStorage:", error);
        }
    }
}
